import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { serversAPI } from '../api';
import ServerCard from '../components/ServerCard';

function Dashboard({ setIsAuthenticated }) {
  const [servers, setServers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState({});
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const userData = localStorage.getItem('user');
    if (userData) {
      setUser(JSON.parse(userData));
    }
    loadServers();
    // Refresh server status every 10 seconds
    const interval = setInterval(loadServers, 10000);
    return () => clearInterval(interval);
  }, []);

  const loadServers = async () => {
    try {
      const response = await serversAPI.getAll();
      setServers(response.data);
    } catch (error) {
      console.error('Failed to load servers:', error);
      if (error.response?.status === 401) {
        handleLogout();
      }
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setIsAuthenticated(false);
    navigate('/');
  };

  const handleServerAction = async (serverId, action, apiCall) => {
    setActionLoading({ ...actionLoading, [serverId]: true });
    try {
      await apiCall(serverId);
      // Reload servers after action
      setTimeout(loadServers, 1000);
    } catch (error) {
      alert(`Failed to ${action} server: ${error.response?.data?.error || error.message}`);
    } finally {
      setActionLoading({ ...actionLoading, [serverId]: false });
    }
  };

  if (loading) {
    return <div className="loading">Loading servers...</div>;
  }

  return (
    <div className="dashboard">
      <div className="container">
        <div className="dashboard-header">
          <div>
            <h1>Game Server Manager</h1>
            <p style={{ color: '#666', marginTop: '5px' }}>Manage your game servers</p>
          </div>
          <div className="user-info">
            <span>
              Welcome, <strong>{user?.username}</strong>
              {user?.isAdmin && <span className="admin-badge" style={{ marginLeft: '10px' }}>ADMIN</span>}
            </span>
            <button 
              className="btn" 
              onClick={() => navigate('/profile')}
              style={{ padding: '10px 20px', background: '#667eea', marginRight: '10px' }}
            >
              Profile
            </button>
            <button className="logout-btn" onClick={handleLogout}>
              Logout
            </button>
          </div>
        </div>

        {servers.length === 0 ? (
          <div className="empty-state">
            <h2>No Game Servers Available</h2>
            <p>Contact your administrator to get access to game servers.</p>
          </div>
        ) : (
          <div className="servers-grid">
            {servers.map((server) => (
              <ServerCard
                key={server.id}
                server={server}
                onStart={(id) => handleServerAction(id, 'start', serversAPI.start)}
                onStop={(id) => handleServerAction(id, 'stop', serversAPI.stop)}
                onRestart={(id) => handleServerAction(id, 'restart', serversAPI.restart)}
                loading={actionLoading[server.id]}
                isAdmin={user?.isAdmin}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Dashboard;
